import React, { useState } from "react";
import { toast } from "react-toastify";
import { Form, Button, Container, Row, Col, Card } from "react-bootstrap";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import ApiService from "../services/ApiService";
import logo from "../assets/images/logo.png";
import OtpInput from 'react-otp-input';
        
const ResetPassword = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const basePath = process.env.REACT_APP_BASE_PATH;
  const [isLoader, setIsLoader] = useState(false);
  const [otp, setOTP] = useState(searchParams.get('otp') || '');
  const email = searchParams.get('email');

  const [formData, setFormData] = useState({
    email,
    otp: "",
    password: "",
    confirm_password: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoader(true);
    try {
      formData.otp = otp;
      const response = await ApiService.request({
        method: "POST",
        url: `resetPassword`,
        data: formData,
      });
      const data = response.data;
      if (data.status) {
        toast.success(data.message);
        let user = data.data.admin;
        user.auth_token = data.data.auth_token;
        localStorage.setItem('admin', JSON.stringify(user));
        localStorage.setItem('permissions', JSON.stringify(data.data.permissions));
        window.location.href=process.env.REACT_APP_BASE_PATH+'/dashboard';

      } else {
        toast.error(data.message);
      }
      setIsLoader(false);
    } catch (error) {
      console.log(error);
      toast.error("ResetPassword failed!");
      setIsLoader(false);
    }
  };

  return (
    <>
     

      <Container fluid className="">


        <Row className="justify-content-center">
          <Col md={12} className="p-4 mt-5 text-center">
            <h4 className="mb-3"> Rest your Password</h4>
            <p>
              We have sen't otp to your email enter here to make your active and enjoy our services.
            </p>
            <p>
              Please do not share that email with anyone. <br />
            </p>
          </Col>
          <Col md={5} className="signIn-form ">
            <Card className="p-4">
              <h5 className="fw-light mb-4">
                Enter OTP:
              </h5>

              <Form onSubmit={handleSubmit}>
                <Form.Group controlId="username" className="mb-3 ">
                  <Form.Label>* OTP:</Form.Label>
                  <OtpInput
                      value={otp}
                      onChange={(value) => setOTP(value)}
                      numInputs={4}
                      separator={<span>-</span>}
                      renderInput={(props) => <input {...props} style={{ width:'50px',margin:'10px', borderRadius:'5px', border: '1px solid #ccc', padding: '8px', fontSize: '18px', textAlign:'center' }} />}
                  />
                </Form.Group>
                <Form.Group controlId="email" className="mb-3">
                  <Form.Label>New Password*</Form.Label>
                  <Form.Control
                    type="text"
                    name="password"
                    placeholder="Enter New Password"
                    value={formData.password}
                    onChange={handleChange}
                    required
                    className="w-75 inp-s"
                  />
                </Form.Group>
                <Form.Group controlId="email" className="mb-3">
                  <Form.Label>Confirm Password*</Form.Label>
                  <Form.Control
                    type="text"
                    name="confirm_password"
                    placeholder="Enter Confirm Password"
                    value={formData.confirm_password}
                    onChange={handleChange}
                    required
                    className="w-75 inp-s"
                  />
                </Form.Group>


                <Button type="submit" className="w-50 btn btn-base rounde-pill btn-lg"   disabled={isLoader}>
                  Save Password
                  {isLoader &&  <div class="spinner-border spinner-border-sm mx-2" role="status">    </div> } 
                </Button>
              </Form>

           
            </Card>
          </Col>

        </Row>

      </Container>
    </>
  );
};

export default ResetPassword;
